import { React, useState, useEffect } from 'react'
import { Button, Dialog } from 'components/ui'
import { HiPlusCircle } from 'react-icons/hi'
import SocialNetworkTableSearch from './SocialNetworkTableSearch'
import SocialNetworkNew from 'views/socialnetwork/SocialNetworkNew'
import SocialNetworkTableLocation from './SocialNetworkTableLocation'
import SocialNetworkTableLayout from './SocialNetworkTableLayout'
import {
	// useDispatch,
	useSelector,
} from 'react-redux';
import { useTranslation } from 'react-i18next';

const SocialNetworkTableTools = () => {
	const { t } = useTranslation();
	const [viewOpen, setViewOpen] = useState(false)
	const dialogState = useSelector((state) => state.SelectedSocialsForm.data.dialogState);
	const changedLayout = useSelector((state) => state.SelectedSocialsForm.data.changedLayout);
	const [layoutKey, setLayoutKey] = useState(0);

	useEffect(() => {
		setState()
	}, [dialogState]);

	const setState = () => {
		if (dialogState === true) {
			setViewOpen(false)
		}
	}

	useEffect(() => {
		setLayoutKey(layoutKey + 1);
	}, [changedLayout]);


	const onViewOpen = () => {
		setViewOpen(true)
	}

	const onDialogClose = () => {
		setViewOpen(false)
	}

	return (
		<div className="flex flex-col lg:flex-row lg:items-center md:gap-2 lg:gap-0">
			<SocialNetworkTableLayout key={layoutKey} />
			<SocialNetworkTableLocation />
			<SocialNetworkTableSearch />
			<Dialog
				width={'100%'}
				isOpen={viewOpen}
				onClose={onDialogClose}
				onRequestClose={onDialogClose}
			>
				<SocialNetworkNew />

			</Dialog>
			<div className="block lg:inline-block md:mb-0 mb-4">
				<Button
					onClick={() => onViewOpen()}
					block
					variant="solid"
					size="sm"
					icon={<HiPlusCircle />}
				>
					{t('translation.register')}
				</Button>
			</div>
		</div>
	)
}

export default SocialNetworkTableTools